import { store$ } from "@redux/store";
import { distinctUntilChanged, filter, map, pairwise, startWith } from "rxjs";
import ModalStep from "../enums/modalStep";
import { selectModalStep } from "./selectors";

/**
 * @constant selectModal$
 * @description Observable that emits an object containing the current and previous modal steps
 *              whenever the modal step changes. Used to provide context for event tracking.
 * @type {Observable<{ currentStep: string, previousStep: string }>}
 */
export const selectModal$ = store$.pipe(
  map(selectModalStep), 
  distinctUntilChanged(),  
  filter((step) => step !== null), 
  startWith(ModalStep.DateTimeSelection.toString()), 
  pairwise(),
  map(([previousStep, currentStep]) => ({
    currentStep: currentStep?.toString(),
    previousStep: previousStep?.toString(),
  })),
)

export default selectModal$;